import { ICommand, IDefineCommand, IQuery, IQueryMediator } from 'core-ts-types';
import { AppointmentsCommandServant } from '../servants/appointments_command_servant';

angular
  .module('capability-ng-appointments')
  .factory(
    'alternateAppointmentTimesConfirmationCommand',
    (
      defineCommand: IDefineCommand,
      $http: ng.IHttpService,
      QueryMediator: IQueryMediator,
      ngAppointmentsCommandServant: AppointmentsCommandServant,
      log: any
    ): ICommand => {
      return defineCommand('alternateAppointmentTimesConfirmationCommand', (deferred: ng.IDeferred<any>): void => {
        const alternateAppointmentConfirmCommansParams =
          ngAppointmentsCommandServant.alternateAppointmentConfirmCommandParams;
        ngAppointmentsCommandServant
          .request({
            url: 'appointment_requests',
            method: 'POST',
            data: alternateAppointmentConfirmCommansParams
          })
          .then((response: any) => {
            deferred.resolve(response);
          })
          .catch(() => {
            log.error('Unable to create appointment');
            deferred.reject();
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/commands/alertnate_appointment_times_confirmation_command.ts